/**
 * Mouse Tooltip Translator - PDF & Netflix YouTube dual subs — hover translation
 *
 * Declares a single web-accessible-resource entry to every origin with no
 * `use_dynamic_url`, exposing six named files: a bundled pdf.js viewer, `ocr.html`,
 * `opencvHandler.html`, `googleDocInject.js`, `subtitle.js` and `popup.html`. All are
 * reachable from any page at a fixed URL.
 *
 * No image is exposed, so the primary signal is a fetch of `opencvHandler.html` — a
 * distinctive, vendor-specific page that no generic extension would ship.
 *
 * Manifest verified against version 0.1.242.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'hmigninkgibhdckiaphhmbgcghochdjc';

export const mouseTooltipTranslator: ExtensionDefinition = {
  id: ID,
  name: 'Mouse Tooltip Translator - PDF & Netflix YouTube dual subs',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Six named files exposed to every origin with no dynamic URL. A single fetch of the ' +
    'distinctive opencvHandler.html is conclusive.',
  signals: [
    {
      id: 'war-opencv-handler-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch opencvHandler.html — a distinctive, vendor-specific page exposed to every ' +
        'origin, identifying this extension unambiguously.',
      weight: 1,
      run: () => probeFetch(ID, 'opencvHandler.html'),
    },
    {
      id: 'war-subtitle-js',
      kind: 'web-accessible-resource',
      description: 'Fetch subtitle.js — the dual-subtitle script, corroborating the match.',
      weight: 0.5,
      run: () => probeFetch(ID, 'subtitle.js'),
    },
    {
      id: 'war-ocr-html',
      kind: 'web-accessible-resource',
      description: 'Fetch ocr.html — the OCR page, a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'ocr.html'),
    },
  ],
};
